/** @const {number} SCROLL_BY_X_PIXELS Amount of PX the content is scroll by when user clicks on a scroll button */
const SCROLL_BY_X_PIXELS = 100;

/** @const {number} SCROLL_INTERVAL Interval between scroll by when user clicks on a scroll button in ms */
const SCROLL_INTERVAL = 100;

// Wait for immediately attached event listeners
// Call on load a first time to show scroll buttons if needed

document.querySelectorAll(".js-horizontal-scroll-wrapper").forEach((el) => {
  setupHorizontalScrollWrapper(el);
});
/**
 * Setup a series of event listener for scroll buttons to work.
 * Returns a function to be called by any function adding / removing filters.
 *
 * @returns {Function}
 */
function setupHorizontalScrollWrapper(horizontalScrollWrapperEl) {
  if (!horizontalScrollWrapperEl) return;

  const scrollRightBtn = horizontalScrollWrapperEl.querySelector(".js-scroll-right-btn");
  const scrollLeftBtn = horizontalScrollWrapperEl.querySelector(".js-scroll-left-btn");

  const scrollBy = (X) => () => horizontalScrollWrapperEl.scrollBy({ left: X, behavior: "smooth" });
  const scrollRight = scrollBy(SCROLL_BY_X_PIXELS);
  const scrollLeft = scrollBy(-SCROLL_BY_X_PIXELS);

  let scrollInterval;

  scrollRightBtn.addEventListener("click", () => scrollRight());
  scrollRightBtn.addEventListener("mousedown", () => {
    scrollInterval = setInterval(scrollRight, SCROLL_INTERVAL);
  });
  scrollRightBtn.addEventListener("mouseup", () => {
    clearInterval(scrollInterval);
  });

  scrollLeftBtn.addEventListener("click", () => scrollLeft());
  scrollLeftBtn.addEventListener("mousedown", () => {
    scrollInterval = setInterval(scrollLeft, SCROLL_INTERVAL);
  });
  scrollLeftBtn.addEventListener("mouseup", () => {
    clearInterval(scrollInterval);
  });

  function updateHorizontalScrollWrapper() {
    const scrolledByLeftEdge = horizontalScrollWrapperEl.scrollLeft;
    const scrolledWidth = Math.floor(scrolledByLeftEdge + horizontalScrollWrapperEl.clientWidth);

    const showLeftScrollButton = scrolledByLeftEdge > 1;

    const showRightScrollButton = scrolledWidth < horizontalScrollWrapperEl.scrollWidth - 1;

    if (showLeftScrollButton) {
      scrollLeftBtn.classList.toggle("hidden", false);
    } else if (!scrollLeftBtn.classList.contains("hidden")) {
      // Clearing interval is required because we are hiding the button thus we might miss the mouseup event
      clearInterval(scrollInterval);
      // scroll one more time avoid being just a few pixels away from the edge
      scrollLeft();
      scrollLeftBtn.classList.add("hidden");
    }

    if (showRightScrollButton) {
      scrollRightBtn.classList.toggle("hidden", false);
    } else if (!scrollRightBtn.classList.contains("hidden")) {
      // Clearing interval is required because we are hiding the button thus we might miss the mouseup event
      clearInterval(scrollInterval);
      // scroll one more time avoid being just a few pixels away from the edge
      scrollRight();
      scrollRightBtn.classList.add("hidden");
    }
  }

  // On resize of the page we need to check again if we should show scroll buttons
  const resizeObserver = new ResizeObserver(() => updateHorizontalScrollWrapper());
  resizeObserver.observe(horizontalScrollWrapperEl);

  horizontalScrollWrapperEl.addEventListener("scroll", updateHorizontalScrollWrapper);
}
